var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconError = function SvgIconError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.674,
    height: 15.673,
    viewBox: "0 0 15.674 15.673",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M86.729,87a7.837,7.837,0,1,0,7.837,7.837A7.846,7.846,0,0,0,86.729,87Zm0,14.795a6.958,6.958,0,1,1,6.959-6.958A6.967,6.967,0,0,1,86.729,101.795Z",
    transform: "translate(-78.892 -87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M106.779,107.581a.439.439,0,0,0-.621,0l-3.029,3.029L100.1,107.58a.439.439,0,0,0-.621.621l3.029,3.029-3.029,3.029a.439.439,0,1,0,.621.621l3.029-3.029,3.029,3.029a.439.439,0,1,0,.621-.621l-3.029-3.029,3.029-3.029A.439.439,0,0,0,106.779,107.581Z",
    transform: "translate(-95.292 -103.394)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_error.6ee6ccdc.svg";
export { ForwardRef as ReactComponent };